import { TYPE_CUSTOM, TYPE_INSTAGRAM_STORY } from '../../../../constants/networks';
import useRouter from '../../../../../src/composables/use-router';

export default function useTaskDelivery() {
    const router = useRouter().get();

    const hasType = (task) => {
        return task.hasOwnProperty('type');
    };

    const hasOnlyOneDeliverable = (task) => {
        return task.quantity === 1;
    };

    const showContentApprovalDeliverables = (task, approved = false, deliverable = null) => {
        return task.requires_approval && !approved && (!hasOnlyOneDeliverable(task) || deliverable === null);
    };

    const showContentApprovalDeliverable = (task, approved = false) => {
        return task.requires_approval && !approved && hasOnlyOneDeliverable(task);
    };

    const determineDeliveryPage = (task, approved = false, deliverable = null) => {
        const params = {
            brief_id: task.brief_id,
            task_id: task.id
        };

        let name = task.requires_approval
            ? 'v2.activation.brief.task.deliverable.delivery'
            : 'v2.activation.brief.task.delivery';

        if (showContentApprovalDeliverables(task, approved, deliverable)) {
            name = 'v2.activation.brief.task.deliverables';
        } else if (showContentApprovalDeliverable(task, approved)) {
            params.deliverable_id = deliverable.id;
            name = 'v2.activation.brief.task.deliverable';
        } else if (task.type === TYPE_INSTAGRAM_STORY) {
            name = task.requires_approval
                ? 'v2.activation.brief.task.deliverable.delivery.story'
                : 'v2.activation.brief.task.delivery.story';
        } else if (task.type === TYPE_CUSTOM) {
            name = task.requires_approval
                ? 'v2.activation.brief.task.deliverable.delivery.custom'
                : 'v2.activation.brief.task.delivery.custom';
        }

        return {
            name,
            params
        };
    };

    const goToDeliveryPage = (task, approved = false, deliverable = null, extraParams = {}) => {
        if (!hasType(task)) {
            return;
        }

        const { name, params } = determineDeliveryPage(task, approved, deliverable);
        const combinedParams = {
            ...params,
            ...extraParams
        };
        router.push({
            name,
            params: combinedParams
        });
    };

    const goToDeliverablePage = (deliverable, extraParams = {}) => {
        if (!deliverable.requires_approval) {
            return;
        }

        const combinedParams = {
            deliverable_id: deliverable.id,
            ...extraParams
        };

        router.push({
            name: 'v2.activation.brief.task.deliverable',
            params: combinedParams
        });
    };

    return {
        goToDeliveryPage,
        goToDeliverablePage,
        determineDeliveryPage
    };
}
